import useTypedContext from "hooks/useTypedContext";
import useCanCreateApiKeys from "shared/ApiKey/access/useCanCreateApiKeys";

import { SettingsContext } from "../Context";
import { SEAT_LIMITS_TOOLTIP } from "../SeatLimitsNotification/constants";
import useSeatLimit from "../SeatLimitsNotification/useSeats";

const useApiKeysCreateAccess = () => {
  const { seats } = useTypedContext(SettingsContext);
  const { isLimitReached } = useSeatLimit(seats.apiKey);
  const canCreateApiKeys = useCanCreateApiKeys();

  return {
    canCreateApiKeys,
    isCreateDisabled: isLimitReached,
    createDisabledTooltip: SEAT_LIMITS_TOOLTIP,
  };
};

export default useApiKeysCreateAccess;
